import React from "react";
import PopularityBar from "./component/TrudatPopularityBar";

export default class TrudatPopular extends React.Component {
  render() {
    if (!this.props.settings.map || this.props.settings.length === 0) {
      return null;
    }

    return (
      <div className="hp__box__popular-wrapper">
        <h1> Najpopularniejsze </h1>
        <div className="hp__box__popular_bars-wrapper">
          {this.props.settings.map(data => <PopularityBar data={data} />)}
        </div>
      </div>
    );
  }
}
